import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from '@material-ui/core';
import SearchInput from 'Components/lto/common/SearchInput';
import CustomerCard from 'Components/lto/order/CustomerCard';
import Header from 'Components/lto/common/Header';
import {T} from 'Actions/translate';
import BackTop from 'Components/common/BackTop';
import {
    updateDetachedFlag,
    updateShowOtherCustomerButton,
    updateIsLastPage,
    getCustomerList,
} from 'Actions/customer';
import {
    updateProductSearchFields,
    getShipToOfNotSC,
    updateFromShoppingCart,
    updateFromProductSearch,
} from 'Actions/order';
import ScrollWrapper from '../common/ScrollWrapper';
import BasicButton from 'Components/lto/common/BasicButton';
import {setUserData} from 'Actions/localData';
import LoadingIcon from 'Components/icons/LoadingIcon';
import Dialog from 'Components/common/Dialog';
import {USER_ROLE, PURCHASE_ORDER_MODE, BT_TYPE} from 'Utils/constant';
import util from 'Utils/commonUtil';
import {loadIdToken} from 'Utils/jwtUtil';

class SelectCustomer extends Component {
    pager = {
        customer: {pageNum: 0, pageSize: 10},
        otherCustomer: {pageNum: 0, pageSize: 10},
    };

    state = {
        detachedFlag: false,
        listLoaded: true,
        pageLoad: true,
        searchValue: '',
        dealOrderDialogOpened: false,
    };

    constructor() {
        super();

        this.searchBtn = React.createRef();
    }

    async componentWillMount() {
        await this.props.updateProductSearchFields('');
        await this.props.updateDetachedFlag(false);
        await this.props.updateShowOtherCustomerButton(false);
        await this.props.updateIsLastPage(false);
        if (loadIdToken()) {
            this.getList();
        } else {
            window.location.replace(
                `${window.location.origin}/purchase/sso/selectCustomer`,
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.listLoaded !== this.state.listLoaded) {
            if (this.state.listLoaded && this.state.pageLoad) {
                // console.log("1111111111");
                this.setState({pageLoad: false});
            }
        }
    }

    getList = () => {
        if (this.state.listLoaded === false || this.props.isLastPage === true)
            return;

        this.setState({listLoaded: false}, () => {
            // console.log("2222222222");
        });

        let moduleFlag = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            this.getList(routerState.moduleFlag);
            moduleFlag = routerState.moduleFlag;
        }

        this.props
            .getCustomerList({
                pageNum:
                    this.props.detachedFlag === false
                        ? ++this.pager.customer.pageNum
                        : ++this.pager.otherCustomer.pageNum,
                pageSize: this.pager.customer.pageSize,
                queryKey: this.state.searchValue,
                moduleFlag: moduleFlag,
            })
            .then((res) => {
                if (this.props.detachedFlag === false) {
                    this.pager.customer.pageNum = res.pageNum || 1;
                } else {
                    if (this.props.showOtherCustomerButton === true)
                        this.props.updateShowOtherCustomerButton(false);
                    this.pager.otherCustomer.pageNum = res.pageNum || 1;
                }

                this.setState({listLoaded: true}, () => {
                    // console.log("3333333333");
                });
            });
    };

    handleChange = (name, value) => {
        this.setState({[name]: value});
    };

    handleSearch = async () => {
        this.pager.customer.pageNum = 0;
        this.pager.otherCustomer.pageNum = 0;
        await this.props.updateDetachedFlag(false);
        await this.props.updateShowOtherCustomerButton(false);
        await this.props.updateIsLastPage(false);

        this.getList();
    };

    gotoUsercenter = () => this.props.history.push('/usercenter');

    goToProductList = (customerDetails, purchaseOrderMode) => {
        const {localData} = this.props;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        localStorage.setItem('ltoPurchaseOrderMode', '');
        localStorage.setItem('purchaseCustomerEmail', '');
        localStorage.setItem('purchaseCustomerName', '');

        localStorage.setItem('ltoPurchaseOrderMode', purchaseOrderMode);

        let customerName = '';
        if (customerDetails.lastName || customerDetails.firstName) {
            customerName = customerDetails.lastName + customerDetails.firstName;
        }

        localStorage.setItem('purchaseCustomerEmail', customerDetails.email);
        localStorage.setItem('purchaseCustomerName', customerName);

        if (!routerState) {
            if (
                localData.roleType === USER_ROLE.SALES ||
                localData.roleType === USER_ROLE.ADMIN
            ) {
                this.props
                    .getShipToOfNotSC({
                        shipToNum: customerDetails.shipToNo,
                    })
                    .then((res) => {
                        if (res.status === 'success') {
                            this.props.updateFromShoppingCart(false);
                            this.props.updateFromProductSearch(false);
                            if (
                                res.data &&
                                (res.data.length <= 0 ||
                                    (res.data.length > 0 &&
                                        !res.data[0].supplyCenterId))
                            ) {
                                this.props.history.push(
                                    `/purchase/notSupplyCenter`,
                                    {
                                        shipToNumber: customerDetails.shipToNo,
                                        customerEmail:
                                            util.getPurchaseCustomerEmail(),
                                        customerName:
                                            util.getPurchaseCustomerName(),
                                        fromSelectCustomerPage: true,
                                    },
                                );
                            } else {
                                this.setUserDataHandle(
                                    customerDetails,
                                    purchaseOrderMode,
                                );
                            }
                        }
                    });
            }
        }
    };

    setUserDataHandle = (customerDetails) => {
        const {localData} = this.props;
        this.props.setUserData({
            data: {
                email: customerDetails.email,
                shipToNum: customerDetails.shipToNo,
                isProxyProcess: true,
                type: localData.roleType,
                name: localData.name,
            },
        });

        this.props.history.push('/purchase/productList?isProxyUser=1', {
            customerEmail: util.getPurchaseCustomerEmail(),
            customerName: util.getPurchaseCustomerName(),
            fromSelectCustomerPage: true,
        });
    };

    goBack = () => this.props.history.goBack();

    onlineOrderHandle = (e, customerDetails) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }

        let purchaseOrderMode = PURCHASE_ORDER_MODE.ONLINE;

        this.goToProductList(customerDetails, purchaseOrderMode);
    };

    offlineOrderHandle = (e, customerDetails) => {
        if (
            customerDetails.btType &&
            customerDetails.btType === BT_TYPE.DEALER
        ) {
            this.setState({
                dealOrderDialogOpened: true,
            });
        } else {
            if (e && e.stopPropagation) {
                e.stopPropagation();
            } else {
                window.e.cancelBubble = true;
            }

            let purchaseOrderMode = PURCHASE_ORDER_MODE.OFFLINE;
            this.goToProductList(customerDetails, purchaseOrderMode);
        }
    };

    closeDialog = (name) => {
        if (this.state[name]) {
            this.setState({
                [name]: false,
            });
        }
    };

    render() {
        const {listLoaded, pageLoad, dealOrderDialogOpened} = this.state;
        const {showOtherCustomerButton, isLastPage, customerList, localData} =
            this.props;
        // console.log("this.state.listLoaded", this.state.listLoaded);
        console.log('this.state.pageLoad', this.state.pageLoad);

        return (
            <div className="select-customer">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    hasArrowBackIos={true}
                    hasUserCenter={true}
                    ltoPageTitle={T('selectCustomer')}
                    backEvent={this.goBack}>
                    <Grid
                        className="page-search-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-search" item xs={11}>
                            <SearchInput
                                title={'searchValue'}
                                onChange={this.handleChange}
                                placeholder={T('searchCustomer')}
                                search={this.handleSearch}
                                testid="select-customer-search-input"
                            />
                        </Grid>
                    </Grid>

                    <Grid
                        className="lto-customer-point-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="lto-customer-point" item xs={11}>
                            <img
                                src={
                                    new URL(
                                        'Images/customer_point_message.svg',
                                        import.meta.url,
                                    ).href
                                }
                                alt=""
                            />
                            <span className="lto-customer-point-message">
                                {T(
                                    'lto_purchase_order_purchase_order_have_point',
                                )}
                            </span>
                        </Grid>
                    </Grid>
                </Header>

                {pageLoad ? (
                    <LoadingIcon className="page-loading circle-animation" />
                ) : (
                    <ScrollWrapper
                        showLoadingMore={!listLoaded}
                        showAbyss={showOtherCustomerButton || isLastPage}
                        getMoreData={() => this.getList()}
                        listLoaded={listLoaded}>
                        {listLoaded && customerList.length === 0 && (
                            <Grid className="customer-list" item xs={11}>
                                <div
                                    className="notFound"
                                    testid="select-customer-not-found">
                                    {' '}
                                    - {T('notFoundCustomer')} -{' '}
                                </div>
                            </Grid>
                        )}
                        <Grid
                            className="customer-list-container no-margin"
                            container
                            spacing={0}
                            justify={'center'}>
                            {customerList.map((customer, i) => (
                                <Grid
                                    className="customer-list"
                                    key={'customer' + i}
                                    item
                                    xs={11}>
                                    <CustomerCard
                                        customerDetails={customer}
                                        locked={customer.blackFlag}
                                        onlineOrderHandle={
                                            this.onlineOrderHandle
                                        }
                                        offlineOrderHandle={
                                            this.offlineOrderHandle
                                        }
                                        isDealerCustomerFlag={
                                            i === 0 ? true : false
                                        }
                                    />
                                </Grid>
                            ))}
                        </Grid>
                        <BackTop />
                    </ScrollWrapper>
                )}

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={() =>
                        this.closeDialog('dealOrderDialogOpened')
                    }
                    opened={dealOrderDialogOpened}
                    isBottomDialog={true}
                    options={{bgClickClose: false}}>
                    <div
                        className="dealer-warning-dialog"
                        testid="dealer-order-notice-dialog">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>
                                    {T('lto_purchase_order_please_advised')}
                                </span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            testid="dealer-order-notice-message"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid item xs={10}>
                                {T('dealer_customer_info')}
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="close-confirm-btn"
                                    testid="dealer-order-notice-close-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={() =>
                                        this.closeDialog(
                                            'dealOrderDialogOpened',
                                        )
                                    }>
                                    <div>
                                        {T('lto_purchase_order_close_tip_info')}
                                    </div>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {customer, localData} = state;
    return {
        detachedFlag: customer.detachedFlag,
        showOtherCustomerButton: customer.showOtherCustomerButton,
        isLastPage: customer.isLastPage,
        customerList: customer.customerList,
        localData: localData,
    };
};

const mapDispatchToProps = {
    updateDetachedFlag,
    updateShowOtherCustomerButton,
    updateIsLastPage,
    updateProductSearchFields,
    getShipToOfNotSC,
    getCustomerList,
    setUserData,
    updateFromShoppingCart,
    updateFromProductSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectCustomer);
